import { nextFrame } from "./windowHelper";

/**
 * Creates a scroll position preserver for a scrollable element.
 * Call before a layout-changing operation, then call the returned restore function.
 */
export const preserveScrollPosition = (element?: HTMLElement | null) => {
  const scrollTop = element ? element.scrollTop : window.scrollY;
  const scrollHeight = element ? element.scrollHeight : document.documentElement.scrollHeight;
  const scrollRatio = scrollHeight > 0 ? scrollTop / scrollHeight : 0;

  return () => {
    nextFrame(() => {
      const newScrollHeight = element ? element.scrollHeight : document.documentElement.scrollHeight;
      const newScrollTop = scrollRatio * newScrollHeight;

      if (element) {
        element.scrollTop = newScrollTop;
      } else {
        window.scrollTo({ top: newScrollTop, behavior: "instant" });
      }
    });
  };
};
